import {
  message,
  Table,
} from 'antd';
import { useCallback, useEffect, useState } from 'react';
import getSubscriptionCosts from '../../../../domain/use_cases/costs/getSubscriptionCosts';
import { ICost } from '@leedpulse-monorepo/interfaces';
import { costsColumns } from './costsColumns';

const PREVIEW_SIZE = 5;

const subrowColumns = costsColumns.filter((column) => column.key !== 'provider' && column.key !== 'model');

const LowProfileHeaderCell: React.FC<React.HTMLAttributes<HTMLTableCellElement>> = (props) => (
  <th
    {...props}
    style={{
      ...props.style,
      background: 'transparent',
      fontWeight: 400,
      fontSize: '12px',
      color: '#8c8c8c',
      borderBottom: '1px solid #f0f0f0',
    }}
  />
);

interface CostsListProps {
  subscription: { id: string };
  loading: boolean;
  onlyCredits: boolean;
}

const CostsList: React.FC<CostsListProps> = ({
  subscription,
  loading: parentLoading,
  onlyCredits,
}) => {
  const [costs, setCosts] = useState<ICost[]>([]);

  const [loading, setLoading] = useState<boolean>(false);

  const getCosts = useCallback(async () => {
    try {
      setLoading(true);
      return await getSubscriptionCosts(subscription.id, { limit: PREVIEW_SIZE, onlyCredits });
    } catch (error) {
      message.error((error as Error).message);
    } finally {
      setLoading(false);
    }
  }, [subscription, onlyCredits]);

  useEffect(() => {
    // Synchro avec une source distante : l'etat vient d'un appel reseau, pas du
    // rendu. C'est l'usage d'un effet que la regle autorise ("synchronizing with an
    // external system") ; le setState synchrone est le reset qui precede l'appel.
    // eslint-disable-next-line react/set-state-in-effect
    getCosts().then((result) => setCosts(result?.costs ?? []));
  }, [getCosts]);

  return (
    <Table
      size="small"
      pagination={false}
      loading={loading || parentLoading}
      columns={subrowColumns}
      components={{ header: { cell: LowProfileHeaderCell } }}
      rowKey={(record) => record.id}
      dataSource={costs}
      onRow={(record) => ({
        onClick: async (e) => {
          e.stopPropagation();
          try {
            await navigator.clipboard.writeText(record.id);
            message.success('ID copié dans le presse-papiers');
          } catch {
            message.error('Copie impossible (presse-papiers indisponible)');
          }
        },
      })}
    />
  );
};

export default CostsList;
